import whithGetDocentes from "../hoc/withGetDocentes";
import TodoDocentes from "../view/components/Tablas/ControlCapacitaciones/RelacionDocentes/TodoDocentes";

export default whithGetDocentes(TodoDocentes);